import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./breadcrumb-pill.css";

interface BreadcrumbPillProps {
    href: string;
    title: string;
    onClick: () => void;
}

function BreadcrumbPill({ href, title, onClick }: BreadcrumbPillProps): null | JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick();
    }
    return (
        <a role="button" href={href} onClick={handleClick} className={styles.pill}>
            <span>{title}</span>
            <span className={styles.cross}>
                <SVGIcon name="cross-thin" />
            </span>
        </a>
    );
}

export default BreadcrumbPill;

BreadcrumbPill.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
